module.exports = __webpack_public_path__ + "img/icon_material_cumulative_jhyl.011046e8.webp";